import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { StarRating } from '@shared/components';
import { DistanceFromVenue } from '@shared/components/DistanceFromVenue';
import { TravelLogistics } from '@shared/components/TravelLogistics';
import { SkeletonText } from '@shared/components/Skeleton';
import type { HotelTileDistanceData } from '../HotelTileCard.types';

interface HotelTileDistanceProps
  extends Readonly<{
    starRating?: number;
    distance?: HotelTileDistanceData;
    id?: string;
    hotelLocation?: Readonly<{ lat: number; lng: number }>;
    venueLocation?: Readonly<{ lat: number; lng: number }> | null;
  }> {}

export const HotelTileDistance: React.FC<HotelTileDistanceProps> = ({ starRating, distance, id, hotelLocation, venueLocation }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="flex-start"
      gap={pxToRem(4)}
    >
      {!!starRating && (
        <StarRating
          rating={starRating}
          id={id || 'hotel-tile'}
          hideNonFilledStars
        />
      )}
      {distance && (
        <Flex
          gap={4}
          alignItems="center"
          marginTop={1}
        >
          <DistanceFromVenue
            distances={distance.distances}
            milesToVenue={distance.milesToVenue}
            color="mono10"
            size="sm"
            useToWording
            useShortWording
          />
          {hotelLocation && (
            <TravelLogistics
              distances={distance.distances}
              venueLocation={venueLocation}
              hotelLocation={hotelLocation}
              useShortWording
            />
          )}
        </Flex>
      )}
    </Flex>
  );
};

// Skeleton component for HotelTileDistance
export const HotelTileDistanceSkeleton: React.FC = () => {
  return (
    <SkeletonText
      rows={1}
      width="60%"
      skeletonHeight={pxToRem(16)}
    />
  );
};
